import { all, fork } from 'redux-saga/effects';

import { oldDashboardSaga } from './OldDashboard';
import { dashboardPageSaga } from './DashboardPage';
import { billingSaga } from './Billing';
import { billingDetailsSaga } from './BillingDetails';
import { passwordPageSaga } from './PasswordPage';
import { mobileNumberPageSaga } from './MobileNumberPage';
import { policySaga } from './Policy';
import { insuranceClaimListPageSaga } from './InsuranceClaimListPage';
import { insuranceClaimDetailsPageSaga } from './InsuranceClaimDetailsPage';
import { insuranceClaimEditModalSaga } from './InsuranceClaimEditModal';
import { PolicyClaimSaga } from './PolicyClaim';
import { policyDetailsSaga } from './PolicyDetails';
import { policyRenewalSaga } from './PolicyRenewal';
import { personalInfoEditSaga } from './PersonalInfoEditPage';
import { insurancePolicyListPageSaga } from './InsurancePolicyListPage';
import { insurancePolicyDetailsPageSaga } from './InsurancePolicyDetailsPage';
import { insurancePolicyUserDetailsPageSaga } from './InsurancePolicyUserDetailsPage';
import { searchInsurancePolicyUserPageSaga } from './SearchInsurancePolicyUserPage';
import { policyCommissionInvoiceListPageSaga } from './PolicyCommissionInvoiceListPage';
import { policyCommissionInvoiceDetailsPageSaga } from './PolicyCommissionInvoiceDetailsPage';

export default function* () {
  yield all([
    fork(oldDashboardSaga),
    fork(dashboardPageSaga),
    fork(billingSaga),
    fork(billingDetailsSaga),
    fork(passwordPageSaga),
    fork(mobileNumberPageSaga),
    fork(personalInfoEditSaga),
    fork(policySaga),
    fork(insuranceClaimListPageSaga),
    fork(insuranceClaimDetailsPageSaga),
    fork(PolicyClaimSaga),
    fork(policyDetailsSaga),
    fork(policyRenewalSaga),
    fork(insuranceClaimEditModalSaga),
    fork(insurancePolicyListPageSaga),
    fork(insurancePolicyDetailsPageSaga),
    fork(insurancePolicyUserDetailsPageSaga),
    fork(searchInsurancePolicyUserPageSaga),
    fork(policyCommissionInvoiceListPageSaga),
    fork(policyCommissionInvoiceDetailsPageSaga),
  ]);
}
